import React, { Fragment } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Hidden, IconButton, AppBar, Box, Tooltip } from '@material-ui/core';
import { connect } from 'react-redux';
import {
  setSidebarToggle,
  setSidebarToggleMobile
} from '../../reducers/ThemeOptions';
import projectLogo from '../../../assets/images/logo.svg';

import HeaderLogo from './header_logo';
import HeaderDots from './dots';
import HeaderUserbox from './user_box';

import MenuOpenRoundedIcon from '@material-ui/icons/MenuOpenRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import { BRAND_NAME } from 'eebac/constants';
import LogoText from './logo_text';
import { motion } from "framer-motion";

const Header = props => {
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };
  const {
    headerShadow,
    headerFixed,
    sidebarToggleMobile,
    setSidebarToggleMobile,
    setSidebarToggle,
    sidebarToggle,
    navItems
  } = props;

  return (
    <Fragment>
      <AppBar
        color="secondary"
        className={clsx('app-header', {
          'app-header-collapsed-sidebar': props.isCollapsedLayout
        })}
        position={headerFixed ? 'fixed' : 'absolute'}
        elevation={headerShadow ? 11 : 3}>

        {!props.isCollapsedLayout && <HeaderLogo />}
        <Box className="app-header-toolbar">
          <Hidden lgUp>
            <Box
              className="app-logo-wrapper"
              title="Eebac Admin Dashboard">
              <Link to="/dashboard" className="app-logo-link mr-0">
                <motion.div
                  animate={{
                    scale: [0, 1],
                    rotate: [0, 0, 270, 270, 0],
                    borderRadius: ["20%", "20%", "50%", "50%", "20%"]
                  }}
                  exit="in"
                  transition={{
                    duration: 1,
                    ease: "easeInOut",
                  }}>
                  <IconButton
                    color="primary"
                    size="medium"
                    className="app-logo-btn bg-white">
                    <img
                      className="app-logo-img"
                      alt="Eebac"
                      src={projectLogo}
                    />
                  </IconButton>
                </motion.div>
              </Link>
              <Hidden smDown>
                <LogoText />
              </Hidden>
            </Box>
          </Hidden>
          <Hidden mdDown>
            <Box className="d-flex align-items-center">
              {!props.isCollapsedLayout && (
                <Box
                  className={clsx('btn-toggle-collapse', {
                    'btn-toggle-collapse-closed': sidebarToggle
                  })}>
                  <Tooltip title="Toggle Menubar" placement="right">
                    <IconButton
                      color="inherit"
                      onClick={toggleSidebar}
                      size="medium"
                      className="btn-inverse">
                      {sidebarToggle ? (
                        <MenuRoundedIcon />
                      ) : (
                          <MenuOpenRoundedIcon />
                        )}
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </Box>
          </Hidden>
          <motion.div
            className="MuiBox-root MuiBox-root-56 d-flex align-items-center"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit="in"
            transition={{ duration: 1 }}>
            <Box className="d-flex align-items-center">
              <HeaderUserbox navItems={navItems} />
              <Box className="toggle-sidebar-btn-mobile">
                <Tooltip title="Toggle Sidebar" placement="right">
                  <IconButton
                    color="inherit"
                    onClick={toggleSidebarMobile}
                    size="medium">
                    {sidebarToggleMobile ? (
                      <MenuOpenRoundedIcon />
                    ) : (
                        <MenuRoundedIcon />
                      )}
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </motion.div>
        </Box>
      </AppBar>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  headerShadow: state.ThemeOptions.headerShadow,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
  sidebarToggle: state.ThemeOptions.sidebarToggle
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggle: enable => dispatch(setSidebarToggle(enable)),
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
